export default {
  items: [{
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'fa fa-table'
  }, {
    name: 'Sellout',
    url: '/statistics/index',
    icon: 'fa fa-table'
  }, {
    name: 'Sellin',
    url: '/sellin/index',
    icon: 'fa fa-table'
  }, /* {
    name: 'Incentivos',
    url: '/stars',
    icon: 'fa fa-table',
    auth: ['stars_results.all']
  },  {
    name: 'Incentivos',
    url: '/stars-results',
    icon: 'fa fa-table',
    auth: ['stars_results.results']
  }, */ {
    name: 'Oportunidades',
    url: '/oportunity',
    icon: 'fa fa-table',
    auth: ['oportunity.all']
  }, {
    name: 'Oportunidades',
    url: '/oportunity-self',
    icon: 'fa fa-table',
    auth: ['oportunity.results']
  }, {
    name: 'NIF\'s Excluídos',
    url: '/nifs-excluidos',
    icon: 'fa fa-table'/* ,
    auth: ['oportunity.results'] */
  }, {
    name: 'Operators',
    url: '/operators',
    icon: 'fa fa-table'/* ,
    auth: ['oportunity.results'] */
  }, {
    divider: true
  }, {
    name: 'Utilizadores',
    url: '/users',
    icon: 'fa fa-users',
    auth: ['users.list']
  }, {
    name: 'Grupos',
    url: '/roles',
    icon: 'fa fa-users',
    auth: ['roles.list']
  }, {
    divider: true
  }]
}



// WEBPACK FOOTER //
// ./src/_nav.js